/**
 * Custom `next/image` loader. Returns the src verbatim — no `/_next/image`
 * transform.
 *
 * Why: `scripts/sync-assets.ts` already content-hashes and generates
 * AVIF + WebP variants at upload time. Running Next's optimizer on top
 * (a) bounces every CDN request through this app's server, defeating the
 * point of the CDN, and (b) re-encodes images that are already optimized.
 *
 * `<Image>` still pulls its own weight: layout reservation, lazy loading,
 * `sizes` handling, and `priority` hinting are intact. We just skip the
 * URL rewrite.
 *
 * `width` and `quality` are ignored by design.
 */
export default function imageLoader({ src }: { src: string }): string {
  if (!/^(https?:)?\/\/|^\/|^data:/.test(src)) {
    throw new Error(`imageLoader: invalid src "${src}"`)
  }
  return src
}
